import Login from './login.gql'
import Logout from './logout.gql'
import IgnoreNotice from './IgnoreNotice.gql'
import QueryList from "./queryList.gql";
import FrequentUser from "./frequentUsers.gql";
import {mutationHdl, queryHdl} from '../graphqlHdr'


export default {
  // 登录
  login: (vueSelf, variables) => mutationHdl.call(vueSelf, Login, variables, false),
  // 登出
  logout: (vueSelf, variables) => mutationHdl.call(vueSelf, Logout, variables),
  // 查询人员
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, variables),
  // 常用参会人
  frequentUser: (vueSelf, variables) => queryHdl.call(vueSelf, FrequentUser, variables),
  // 忽略通知
  setIgnoreNotice: (vueSelf, variables) => mutationHdl.call(vueSelf, IgnoreNotice, variables),
};
